<mach-general-modal [id]="id" class="info-popup-modal">
  <div header class="info-popup-modal__header">
    <span *ngIf="content?.title">{{ content.title }}</span>
  </div>
  <div body>
    <div class="info-popup-modal__body">
      <span
        *ngIf="content?.description"
        class="info-popup-modal__body__desc"
        [innerHTML]="content.description"
      ></span>
    </div>
  </div>
</mach-general-modal>
